import React from 'react';
import { TrendingUp } from 'lucide-react';
export function Proof() {
  return <section className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-190">
      <div className="mx-auto max-w-4xl text-center" data-id="element-191">
        <div className="mb-8 flex justify-center" data-id="element-192">
          <div className="rounded-full bg-green-500/10 p-4" data-id="element-193">
            <TrendingUp className="h-12 w-12 text-green-500" data-id="element-194" />
          </div>
        </div>

        <h2 className="mb-8 text-4xl sm:text-5xl font-bebas text-white" data-id="element-195">
          Lo que cambia en <span className="text-green-400" data-id="element-196">30-45 días</span>
        </h2>

        <p className="mb-8 text-xl text-slate-300 leading-relaxed" data-id="element-197">
          Al eliminar una sola colección de $1,000 o una marca de pago tarde, tu
          puntaje suele saltar entre{' '}
          <strong className="text-gold-400 text-2xl" data-id="element-198">40 y 85 puntos</strong> de
          inmediato.
        </p>

        <div className="rounded-xl bg-navy-900 p-8 border-l-4 border-green-500 shadow-xl inline-block text-left" data-id="element-199">
          <p className="text-lg text-white font-medium italic" data-id="element-200">
            "Imagina entrar al banco el próximo mes sabiendo que tu reporte está
            limpio y que tú tienes el control de la conversación."
          </p>
        </div>
      </div>
    </section>;
}